import { useEffect } from 'react'

export function useDraggableModal() {
  useEffect(() => {
    let isDragging = false
    let startX = 0
    let startY = 0
    let currentModal = null
    let startLeft = 0
    let startTop = 0

    const handleMouseDown = (e) => {
      // 只在 Modal 标题区域开始拖动
      if (e.target.closest('.ant-modal-header')) {
        const modal = e.target.closest('.ant-modal')
        if (modal && modal.style.display !== 'none') {
          isDragging = true
          currentModal = modal
          startX = e.clientX
          startY = e.clientY

          // R-fix-2026-08-24 (R5-D3-007): getBoundingClientRect() 返回视觉像素(zoom 0.8 下偏 20%),
          // modal.style.left 是 CSS 像素会被 zoom 再次缩放 → 首帧跳到右下偏 25%。
          // 用 effectiveZoom 把视觉像素换算成布局像素,CSS 写入后 zoom 缩放回视觉位置。
          const rect = modal.getBoundingClientRect()
          const effectiveZoom = parseFloat(getComputedStyle(document.documentElement).zoom) || 1
          startLeft = rect.left / effectiveZoom
          startTop = rect.top / effectiveZoom
          modal.style.position = 'fixed'
          modal.style.left = `${startLeft}px`
          modal.style.top = `${startTop}px`
          modal.style.margin = '0'
        }
      }
    }

    const handleMouseMove = (e) => {
      if (!isDragging || !currentModal) return

      const deltaX = e.clientX - startX
      const deltaY = e.clientY - startY

      currentModal.style.left = `${startLeft + deltaX}px`
      currentModal.style.top = `${startTop + deltaY}px`

      startX = e.clientX
      startY = e.clientY
      startLeft = parseFloat(currentModal.style.left)
      startTop = parseFloat(currentModal.style.top)
    }

    const handleMouseUp = () => {
      isDragging = false
      currentModal = null
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])
}
